<template>
  <div v-if="data">
    <RevCard class="p-24 md:p-32">
      <h2 class="heading-2">
        {{ i18n(translations.title) }}
      </h2>

      <div class="mt-24 grid grid-cols-1 gap-24 md:grid-cols-2">
        <PaymentMethodCard
          v-for="paymentMethod in paymentMethods"
          :key="paymentMethod.name"
          :payment-method
          @settings-clicked="handleSettingsClick"
        />
      </div>
    </RevCard>

    <PayoutMethodAdyen
      v-if="data.adyenInformation"
      :adyen-information="data.adyenInformation"
    />
    <PayoutMethodHyperwallet
      v-if="data.hyperwalletInformation && hasHyperWalletEnabled"
      :hyperwallet-information="data.hyperwalletInformation"
    />

    <ModalKonbiniSettings />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { merchantsAPI } from '@backmarket/http-api'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { openModal } from '@ds/components/ModalBase'

import { useBusinessFeaturesStore } from '~/scopes/config/stores/businessFeaturesStore'

import { MODAL_NAMES } from './Payment.constants'
import translations from './Payment.translations'
import ModalKonbiniSettings from './components/Modals/ModalKonbiniSettings/ModalKonbiniSettings.vue'
import PaymentMethodCard from './components/PaymentMethodCard/PaymentMethodCard.vue'
import PayoutMethodAdyen from './components/Payout/PayoutMethodAdyen/PayoutMethodAdyen.vue'
import PayoutMethodHyperwallet from './components/Payout/PayoutMethodHyperwallet/PayoutMethodHyperwallet.vue'

const i18n = useI18n()
const { isFeatureEnabled } = useBusinessFeaturesStore()

const { data } = await useHttpFetch(merchantsAPI.getPaymentMethods)

const hasHyperWalletEnabled = isFeatureEnabled('hwEnabled')

const paymentMethods = computed(() => data.value?.paymentMethods || [])

function handleSettingsClick(name: merchantsAPI.PaymentMethod['name']) {
  if (name === 'konbini') {
    openModal(MODAL_NAMES.KONBINI_SETTINGS)
  }
}
</script>
